import { render } from "./Link.vue?vue&type=template&id=9e9ab906&ts=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__